import { render, staticRenderFns } from "./BattleLobby.vue?vue&type=template&id=d2c63df2&"
import script from "./BattleLobby.vue?vue&type=script&lang=ts&"
export * from "./BattleLobby.vue?vue&type=script&lang=ts&"
import style0 from "./BattleLobby.vue?vue&type=style&index=0&id=d2c63df2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports